import * as _ from 'lodash-es';
import React from 'react';
import * as styles from './ExtensionCommentThread.module.scss';
import Avatar from '../../../components/Avatar';
import Button from '../../../components/Button';
import DeltaPreview from '../../../components/DeltaPreview';
import PopOver from '../../../components/deprecated/PopOver';
import Timestamp from '../../../components/Timestamp';
import { MentionBaseProvider } from '../../../editor/mentions/MentionBase';
import type { DocumentType } from '../../../graphql/generated/gql';
import { gql } from '../../../graphql/generated/gql';
import postPath from '../../../utils/url/postPath';

const POST_FRAGMENT = gql(`
  fragment ExtensionCommentThread_post on Post {
    ...postPath_post
  }
`);

const THREAD_FRAGMENT = gql(`
  fragment ExtensionCommentThread_thread on CommentThread {
    id
    comments {
      id
      insertedAt
      content
      author {
        ...Avatar_user
      }
    }
  }
`);

interface CommentThreadProps {
  thread: DocumentType<typeof THREAD_FRAGMENT>;
  post: DocumentType<typeof POST_FRAGMENT>;
  activeThreadId: string | null;
  onActiveThreadIdChange: (threadId: string | null) => void;
}

const CommentThread = ({
  thread,
  post,
  activeThreadId,
  onActiveThreadIdChange,
}: CommentThreadProps) => {
  const lastComment = _.last(thread.comments);
  if (!lastComment) return null;
  const avatar = (
    <div className={styles.avatar}>
      <Avatar size={28} user={lastComment.author} />
    </div>
  );

  return (
    <div>
      <PopOver
        placement="left-start"
        trigger="click"
        onOpenChange={(newIsOpen) => {
          onActiveThreadIdChange(newIsOpen ? thread.id : null);
        }}
        open={activeThreadId === thread.id}
        preventCloseOnContentClick
        popOver={
          <div className={styles.container}>
            {thread.comments.map((comment) => (
              <div className={styles.comment} key={comment.id}>
                <div className={styles.commentAvatar}>
                  <Avatar size={28} user={comment.author} />
                </div>
                <div className={styles.commentMeta}>
                  <span className={styles.authorName}>
                    {comment.author.name}
                  </span>
                  <span className={styles.time}>
                    <Timestamp date={comment.insertedAt} />
                  </span>
                </div>
                <div className={styles.commentContent}>
                  <MentionBaseProvider containerType="comment">
                    <DeltaPreview
                      typography="comment"
                      content={comment.content}
                    />
                  </MentionBaseProvider>
                </div>
              </div>
            ))}
            <div className={styles.replyButton}>
              <Button
                block
                variant="secondary"
                to={postPath(post, { anchor: `thread-${thread.id}` })}
                target="_blank"
                rel="noopener noreferrer"
              >
                Reply on Slab
              </Button>
            </div>
          </div>
        }
      >
        {avatar}
      </PopOver>
    </div>
  );
};

export default CommentThread;
